import React, { useEffect, useState } from 'react'

import {
  useMasterBillActions,
  useMasterBillState
} from '../stores/useMasterBillStore'

import Button from '@/components/common/Button'
import DatePicker from '@/components/form/DatePicker'
import FreetimePicker from '@/components/form/FreetimePicker'
import { customsV2Service } from '@/services'
import { MasterBillStatus } from '@/services/CustomsV2Service'
import { useUIStore } from '@/stores/useUIStore'

const MasterBillDate: React.FC = () => {
  const [devanDate, setDevanDate] = useState('')
  const [inboundDate, setInboundDate] = useState('')
  const [freetimeDate, setFreetimeDate] = useState('')

  const { masterBill } = useMasterBillState()
  const { updateMasterBill } = useMasterBillActions()

  const { showSuccess, showError } = useUIStore()

  const handleUpdate = async () => {
    if (!masterBill) {
      showError('请选择一个主提单')
      return
    }

    const { success, message, data } =
      await customsV2Service.updateMasterBillDate(masterBill.id, {
        devanDate,
        inboundDate,
        freetimeDate
      })
    if (success && data) {
      showSuccess(message)
      updateMasterBill(data)
    } else {
      showError(message)
    }
  }

  // 当主提单变更时，从主提单数据初始化日期
  useEffect(() => {
    if (masterBill) {
      setDevanDate(masterBill.devanDate || '')
      setInboundDate(masterBill.inboundDate || '')
      setFreetimeDate(masterBill.freetimeDate || '')
    }
  }, [masterBill])

  return (
    <div className="mt-6 border-t border-gray-200 pt-6">
      <div className="flex justify-between">
        <h4 className="text-sm font-medium text-gray-900 mb-4">日期管理</h4>
        <div>
          {masterBill?.status === MasterBillStatus.PENDING_CONFIRMATION && (
            <Button disabled={devanDate === ''} onClick={() => handleUpdate()}>
              更新确认
            </Button>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* 拆柜日期 */}
        <DatePicker
          label="拆柜日期"
          value={devanDate}
          onChange={setDevanDate}
          placeholder="请选择拆柜日期"
          className="w-full"
          disabled={
            masterBill?.status !== MasterBillStatus.PENDING_CONFIRMATION
          }
        />

        {/* 预计入库日期 */}
        <div className="space-y-2">
          <DatePicker
            label="预计入库日期"
            value={inboundDate}
            onChange={setInboundDate}
            placeholder={devanDate ? '请选择预计入库日期' : '请先选择拆柜日期'}
            disabled={
              !devanDate ||
              masterBill?.status !== MasterBillStatus.PENDING_CONFIRMATION
            }
            minDate={devanDate}
            className="w-full"
          />
          {!devanDate && (
            <p className="text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded">
              请先选择拆柜日期
            </p>
          )}
          {devanDate && inboundDate && inboundDate !== devanDate && (
            <p className="text-xs text-gray-500">拆柜日期({devanDate})后入库</p>
          )}
        </div>

        {/* Freetime */}
        <FreetimePicker
          label="Freetime"
          date={inboundDate}
          freetimeDate={freetimeDate}
          onDateChange={setFreetimeDate}
          disabled={
            masterBill?.status !== MasterBillStatus.PENDING_CONFIRMATION
          }
          className="w-full"
        />
      </div>
    </div>
  )
}

export default MasterBillDate
